var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawProjectCompletedUg9I(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 688.29,
    viewBox: "0 0 960 688.29",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-177.895 -136.526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,16.5S37.281,54.936,48.137,84.432A57.219,57.219,0,1,0,103.449,74.7L83.858,0ZM141.655,128.684v0Z",
    transform: "translate(1043.359 503.509) rotate(180)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.137,197.618c-13.143-1.775-26.112-8.877-32.227-20.662s-3.5-28.208,7.543-35.559C4.7,123.348-.777,103.232.087,79.311.95,55.37,27.037,33.351,44.05,16.484a4.458,4.458,0,0,1,.39.266A36.68,36.68,0,0,0,33.74.314C44.417-1.707,55.957,6.281,57.781,17.006c2.145,12.452-7.3,24.484-6.189,37.084.986,11.1,9.739,19.628,17.16,27.937,5.364,5.986,10.485,13.367,11.648,20.992a55.623,55.623,0,0,0,26.555,9.947c8.975.839,18.443-.69,25.787-5.892s13.933-14.033,12.235-22.884c4.5,4.56,4.811,10.478,3.968,16.828a20.734,20.734,0,0,1-10.108,15.18,33.851,33.851,0,0,1-7.2,31.931c-7.086,7.815-34.174,7.167-46.419,6.458a3.93,3.93,0,0,1,1.709,2.178c.543,1.851-.1,3.8-.69,5.627-1.031,3.058-2.047,6.09-3.082,9.147-2.194,6.484-4.513,13.192-9.246,18.123-5.741,5.971-14.218,8.374-22.631,8.375A45.98,45.98,0,0,1,45.137,197.618Zm37.377-43.2.009,0h0Z",
    transform: "translate(1048.821 450.436) rotate(180)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.012,651.577l3.9,81.956s-1.951,107.322,15.611,115.128c8.879,3.938,1.142,33.083,17.629,41.746,12.37,6.478,14.462-5.913,20.942,0a21.849,21.849,0,0,1,4.39,5.094c7.806,13.66,93.63,9.752,105.336-.007s3.9,11.707,13.66,15.611c9.445,3.786,22.537-27.162,14.518-73.37-.253-1.538-.547-3.1-.854-4.683-8.956-44.78,5.112-152.046,2.946-193.492a72.937,72.937,0,0,0-.995-9.445c-5.854-31.22-80.55-94.754-94.515-67.691-17.211,33.407-56.744,2.888-63.534-12.306C284.021,548.168,270.362,595,270.362,595Z",
    transform: "translate(620.19 -108.791)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.337,591.753l-10.7,44.159a2.757,2.757,0,0,0,.052,1.49l48.562,151.753a2.759,2.759,0,0,0,5.367-.53l6.719-59.115a2.76,2.76,0,0,0-.118-1.166L439.641,591.55a2.759,2.759,0,0,0-5.3.205Z",
    transform: "translate(261.124 -56.058)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.831,432.512,268.947,470.4l42.831,138.379,9.884-42.829Z",
    transform: "translate(420.568 106.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.189,723.74c-1.648,4.941-171.32-1.648-172.965-3.3a35.766,35.766,0,0,1-3.623-6.588c-1.548-3.3-2.965-6.588-2.965-6.588l6.588-53.339,168.024-5.963s4.2,45.2,5.057,65.892a49.415,49.415,0,0,1-.116,9.883Z",
    transform: "translate(385.008 21.6)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.68,493.975l-3.3,46.126h74.129V493.975Z",
    transform: "translate(530.963 188.762)",
    fill: "#d6d6e3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.857,500.385l-.443-.089,2.093,19.855H243.7V500.385Z",
    transform: "translate(658.331 197.177)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.224,686.1c-1.648,4.941-171.321-1.648-172.965-3.3a35.765,35.765,0,0,1-3.623-6.588h176.7a49.432,49.432,0,0,1-.116,9.883Z",
    transform: "translate(387.973 59.226)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.026,641.712l-52.686,27.319s-31.221-33.173-50.73-7.806S410.2,694.4,410.2,694.4s66.343-15.611,68.3-37.074S457.026,641.712,457.026,641.712Z",
    transform: "translate(437.419 12.302)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.823,561.794c-1.951,1.952-23.416,17.562-23.416,17.562s-5.854,74.149,1.951,89.761,13.66,15.611,7.806,23.416-13.66,1.951-5.854,15.611,15.611,11.707,9.752,17.562-3.9,7.806-3.9,7.806l-23.414,19.513s14.366,22.88,32.551,21.192,33.8-89.493,33.8-89.493Z",
    transform: "translate(538.136 -93.153)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.68,4.52c-5.57,0-8.33-8.8-14.79-15.058-5.5-5.329-14.682-8.124-20.536-8.544-84.347-6.031-187.7-8.388-187.7-8.388s20.018,24.633,20.018,40.432c0,33.766,42.212,23.942,206.543,23.942S505.981,79.957,505.981,46.19,476.011,4.52,311.68,4.52Z",
    transform: "translate(631.914 765.698)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.573,685.355l-31.221,7.8s-35.123-42.929-72.2-27.318,46.83,46.83,46.83,46.83,44.88,23.415,62.441,3.9S429.573,685.355,429.573,685.355Z",
    transform: "translate(552.681 40.859)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,581.878l17.563,5.849s46.83,171.716-7.806,200.985-115.128,58.54-117.077,50.73-23.416-39.027-17.562-42.929,91.709-50.73,91.709-50.73V613.1Z",
    transform: "translate(697.674 -66.408)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.8,452.785l3.9,93.661L131.28,595.23,226.9,546.446Z",
    transform: "translate(828.534 133.909)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.895 263.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.4,409.573l-108.181,48.3a7.292,7.292,0,0,1-9.621-3.681L20.164,330.027a7.292,7.292,0,0,1,3.681-9.621l108.181-48.3a7.292,7.292,0,0,1,9.621,3.682l55.439,124.166a7.292,7.292,0,0,1-3.681,9.621Z",
    transform: "translate(-19.531 -271.472)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.066,387.555l-65.443,29.22a.618.618,0,0,1-.5-1.128l65.443-29.22a.618.618,0,1,1,.5,1.128Z",
    transform: "translate(-102.584 -339.045)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.734,433.689,171.481,453a.618.618,0,1,1-.5-1.128L214.23,432.56a.618.618,0,0,1,.5,1.128Z",
    transform: "translate(-108.382 -366.177)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.359,473.855l-18.973,8.471a.618.618,0,0,1-.816-.312l-8.229-18.429a.618.618,0,0,1,.312-.816l17.21-7.684a.618.618,0,1,1,.5,1.128l-16.646,7.432,7.725,17.3,17.845-7.968-4.574-10.244a.618.618,0,1,1,1.128-.5l4.826,10.808A.618.618,0,0,1,115.359,473.855Z",
    transform: "translate(-59.379 -379.424)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.742,466.314a.618.618,0,0,1-.538-.017l-8.46-4.424a.618.618,0,1,1,.573-1.1l7.738,4.047,4.722-22.219a.618.618,0,1,1,1.209.257l-4.892,23.016a.619.619,0,0,1-.342.431Z",
    transform: "translate(-71.802 -371.828)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.905,463.343l-65.443,29.22a.618.618,0,0,1-.5-1.128l65.443-29.22a.618.618,0,1,1,.5,1.128Z",
    transform: "translate(-122.485 -383.617)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.573,509.477,205.32,528.789a.618.618,0,1,1-.5-1.128l43.253-19.312a.618.618,0,1,1,.5,1.128Z",
    transform: "translate(-128.283 -410.749)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.2,549.644l-18.973,8.471a.618.618,0,0,1-.816-.312l-8.229-18.429a.618.618,0,0,1,.312-.816l17.21-7.684a.618.618,0,1,1,.5,1.128l-16.646,7.432,7.725,17.3,17.845-7.968-4.574-10.244a.618.618,0,0,1,1.128-.5l4.826,10.808A.618.618,0,0,1,149.2,549.644Z",
    transform: "translate(-79.279 -423.995)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.581,542.1a.618.618,0,0,1-.538-.017l-8.46-4.424a.618.618,0,1,1,.573-1.1l7.738,4.047,4.722-22.219a.618.618,0,1,1,1.209.257l-4.892,23.016a.619.619,0,0,1-.342.431Z",
    transform: "translate(-91.703 -416.4)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.744,539.132,229.3,568.352a.618.618,0,0,1-.5-1.128L294.24,538a.618.618,0,1,1,.5,1.128Z",
    transform: "translate(-142.386 -428.189)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.412,585.266l-43.253,19.312a.618.618,0,1,1-.5-1.128l43.253-19.312a.618.618,0,1,1,.5,1.128Z",
    transform: "translate(-148.184 -455.32)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.037,625.433,164.064,633.9a.618.618,0,0,1-.816-.312l-8.229-18.429a.618.618,0,0,1,.312-.816l17.21-7.684a.618.618,0,1,1,.5,1.128L156.4,615.223l7.725,17.3,17.845-7.968L177.4,614.312a.618.618,0,0,1,1.128-.5l4.826,10.808A.618.618,0,0,1,183.037,625.433Z",
    transform: "translate(-99.18 -468.567)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,617.891a.618.618,0,0,1-.538-.017l-8.46-4.424a.618.618,0,1,1,.573-1.1l7.738,4.047,4.722-22.219a.618.618,0,1,1,1.209.257l-4.892,23.016a.619.619,0,0,1-.342.431l-.011,0Z",
    transform: "translate(-111.604 -460.971)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 199.778,
    height: 46.524,
    rx: 7,
    transform: "translate(435.679 255.845)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.831,1.642A2.192,2.192,0,0,0,1.642,3.831V42.692a2.192,2.192,0,0,0,2.189,2.189H195.946a2.192,2.192,0,0,0,2.189-2.189V3.831a2.192,2.192,0,0,0-2.189-2.189H3.831M3.831,0H195.946a3.831,3.831,0,0,1,3.831,3.831V42.692a3.831,3.831,0,0,1-3.831,3.831H3.831A3.831,3.831,0,0,1,0,42.692V3.831A3.831,3.831,0,0,1,3.831,0Z",
    transform: "translate(435.679 255.845)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.068,155.774a1.947,1.947,0,1,0,0,3.893H193.189a1.947,1.947,0,1,0,0-3.893Z",
    transform: "translate(413.444 115.546)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.065,177.113a1.947,1.947,0,0,0-.008,3.893h89.85a1.947,1.947,0,1,0,0-3.893Z",
    transform: "translate(413.447 105.887)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.679 196.185)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.363,
    cy: 10.363,
    r: 10.363,
    transform: "translate(215.859 12.898)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.529,170.7a1.075,1.075,0,0,1-.647-.215l-.012-.009-2.436-1.863a1.082,1.082,0,1,1,1.317-1.718l1.578,1.21,3.728-4.863a1.082,1.082,0,0,1,1.517-.2h0l-.023.032.024-.032a1.083,1.083,0,0,1,.2,1.517l-4.385,5.718a1.083,1.083,0,0,1-.861.422Z",
    transform: "translate(-206.334 -143.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 199.778,
    height: 46.524,
    rx: 7,
    transform: "translate(0 0)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.831,1.642A2.192,2.192,0,0,0,1.642,3.831V42.692a2.192,2.192,0,0,0,2.189,2.189H195.946a2.192,2.192,0,0,0,2.189-2.189V3.831a2.192,2.192,0,0,0-2.189-2.189H3.831M3.831,0H195.946a3.831,3.831,0,0,1,3.831,3.831V42.692a3.831,3.831,0,0,1-3.831,3.831H3.831A3.831,3.831,0,0,1,0,42.692V3.831A3.831,3.831,0,0,1,3.831,0Z",
    transform: "translate(0 0)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.068,155.774a1.947,1.947,0,1,0,0,3.893H193.189a1.947,1.947,0,1,0,0-3.893Z",
    transform: "translate(-22.235 -140.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.065,177.113a1.947,1.947,0,0,0-.008,3.893h89.85a1.947,1.947,0,1,0,0-3.893Z",
    transform: "translate(-22.232 -149.958)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.679 136.526)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.363,
    cy: 10.363,
    r: 10.363,
    transform: "translate(215.859 16.396)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.529,42.7a1.075,1.075,0,0,1-.647-.215l-.012-.009-2.436-1.863a1.082,1.082,0,0,1,1.317-1.718h0l1.578,1.21,3.728-4.863a1.082,1.082,0,0,1,1.517-.2h0l-.023.032.024-.032a1.083,1.083,0,0,1,.2,1.517l-4.385,5.718a1.083,1.083,0,0,1-.861.422h0Z",
    transform: "translate(-206.334 -11.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 199.778,
    height: 46.524,
    rx: 7,
    transform: "translate(0 0)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.831,1.642A2.192,2.192,0,0,0,1.642,3.831V42.692a2.192,2.192,0,0,0,2.189,2.189H195.946a2.192,2.192,0,0,0,2.189-2.189V3.831a2.192,2.192,0,0,0-2.189-2.189H3.831M3.831,0H195.946a3.831,3.831,0,0,1,3.831,3.831V42.692a3.831,3.831,0,0,1-3.831,3.831H3.831A3.831,3.831,0,0,1,0,42.692V3.831A3.831,3.831,0,0,1,3.831,0Z",
    transform: "translate(0 0)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.068,155.774a1.947,1.947,0,1,0,0,3.893H193.189a1.947,1.947,0,1,0,0-3.893Z",
    transform: "translate(-22.235 -140.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.065,177.113a1.947,1.947,0,0,0-.008,3.893h89.85a1.947,1.947,0,1,0,0-3.893Z",
    transform: "translate(-22.232 -149.958)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10.363,
    cy: 10.363,
    r: 10.363,
    transform: "translate(651.538 268.743)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.529,170.7a1.075,1.075,0,0,1-.647-.215l-.012-.009-2.436-1.863a1.082,1.082,0,1,1,1.317-1.718l1.578,1.21,3.728-4.863a1.082,1.082,0,0,1,1.517-.2h0l-.023.032.024-.032a1.083,1.083,0,0,1,.2,1.517l-4.385,5.718a1.083,1.083,0,0,1-.861.422Z",
    transform: "translate(229.345 112.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(481.464 374.688) rotate(13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.738,0H0V138.688H99.738a1.351,1.351,0,0,0,1.351-1.351V1.351A1.351,1.351,0,0,0,99.738,0ZM5.629,134.86a2.477,2.477,0,1,1,2.477-2.477,2.477,2.477,0,0,1-2.477,2.477Zm0-12.608a2.477,2.477,0,1,1,2.477-2.477,2.477,2.477,0,0,1-2.477,2.477Zm0-12.608a2.477,2.477,0,1,1,2.477-2.477,2.477,2.477,0,0,1-2.477,2.477Zm0-12.608A2.477,2.477,0,1,1,8.105,94.56a2.477,2.477,0,0,1-2.477,2.477Zm0-12.608a2.477,2.477,0,1,1,2.477-2.477,2.477,2.477,0,0,1-2.477,2.477Zm0-12.608a2.477,2.477,0,1,1,2.477-2.477A2.477,2.477,0,0,1,5.629,71.82Zm0-12.608a2.477,2.477,0,1,1,2.477-2.477,2.477,2.477,0,0,1-2.477,2.477Zm0-12.608a2.477,2.477,0,1,1,2.477-2.477A2.477,2.477,0,0,1,5.629,46.6ZM5.629,34A2.477,2.477,0,1,1,8.105,31.52,2.477,2.477,0,0,1,5.629,34Zm0-12.608a2.477,2.477,0,1,1,2.477-2.477,2.477,2.477,0,0,1-2.477,2.477Zm0-12.608A2.477,2.477,0,1,1,8.105,6.3,2.477,2.477,0,0,1,5.629,8.781Z",
    transform: "translate(4.614 0)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.639,5.639,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 5.403)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.638,5.638,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 17.786)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.638,5.638,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 30.394)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.638,5.638,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 43.002)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.638,5.638,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 55.61)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.638,5.638,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 68.218)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.638,5.638,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 80.826)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.638,5.638,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 93.434)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.638,5.638,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 106.042)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.639,5.639,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 118.65)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571,2.251C5,2.251,0,2.22,0,1.126S5,0,5.571,0V.45C2.626.45.716.837.408,1.126c.308.289,2.218.675,5.163.675s4.847-.385,5.161-.673a5.639,5.639,0,0,0-2.4-.549L8.368.13c2.775.281,2.775.8,2.775,1C11.143,2.22,6.142,2.251,5.571,2.251Z",
    transform: "translate(0 131.258)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.995,22.289H1.463A1.465,1.465,0,0,1,0,20.826V1.463A1.465,1.465,0,0,1,1.463,0H50.995a1.465,1.465,0,0,1,1.463,1.463V20.826A1.465,1.465,0,0,1,50.995,22.289Z",
    transform: "translate(32.982 30.732)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.734,2.251H1.126A1.126,1.126,0,1,1,1.126,0H13.734a1.126,1.126,0,1,1,0,2.251Z",
    transform: "translate(51.781 35.122)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.693,2.251H1.126A1.126,1.126,0,1,1,1.126,0H27.693a1.126,1.126,0,0,1,0,2.251Z",
    transform: "translate(44.802 40.751)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.693,2.251H1.126A1.126,1.126,0,1,1,1.126,0H27.693a1.126,1.126,0,1,1,0,2.251Z",
    transform: "translate(44.802 46.379)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawProjectCompletedUg9I);
export default __webpack_public_path__ + "static/media/undraw_project-completed_ug9i.e9d320016a55686953ec4c0b6b2bb04e.svg";
export { ForwardRef as ReactComponent };